// Paginación EN CLIENTE de una tabla que ya tiene todas sus filas en memoria (`PAGE_SIZE` y
// `pageMove` del mock). La tabla que pide páginas al servidor usa `LoadedScopeFooter`, no esto.
import { useMemo, useState } from 'react';

/** Cuántas filas por página pinta el mock. */
export const TABLE_PAGE_SIZE = 30;

export const PREV_PAGE_LABEL = 'Página anterior';
export const NEXT_PAGE_LABEL = 'Página siguiente';
export const PAGER_GROUP_LABEL = 'Paginación de la tabla';

/** Cuántas páginas ocupan esas filas. Una lista vacía sigue siendo una página, como el mock. */
export function pageCountOf(rowCount: number, pageSize: number = TABLE_PAGE_SIZE): number {
    return Math.max(1, Math.ceil(rowCount / pageSize));
}

export interface TablePagerState<T> {
    /** Página vigente, base 0. */
    page: number;
    pageCount: number;
    /** Las filas de la página vigente: lo que la tabla pinta. */
    pageRows: T[];
    setPage: (page: number) => void;
}

export function useTablePager<T>(
    rows: readonly T[],
    pageSize: number = TABLE_PAGE_SIZE,
): TablePagerState<T> {
    const [requestedPage, setPage] = useState(0);
    const pageCount = pageCountOf(rows.length, pageSize);

    // Si un filtro achica la lista, la página pedida puede quedar fuera: se muestra la última.
    const page = Math.min(requestedPage, pageCount - 1);
    const pageRows = useMemo(
        () => rows.slice(page * pageSize, page * pageSize + pageSize),
        [rows, page, pageSize],
    );

    return { page, pageCount, pageRows, setPage };
}
